export default __webpack_public_path__ + "static/media/hector-nav-logo.9cb4a3f4.svg";